import { getItemByIdFactory, getItemByLabelFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum TaskStatusIds {
  TO_BE_DONE = 1,
  IN_PROGRESS = 2,
  ON_HOLD = 3,
  COMPLETE = 4,
}

export function getTaskStatii(): ISelectItem[] {
  return [
    { id: TaskStatusIds.TO_BE_DONE, label: 'TBD' },
    { id: TaskStatusIds.IN_PROGRESS, label: 'In Progress' },
    { id: TaskStatusIds.ON_HOLD, label: 'On Hold' },
    { id: TaskStatusIds.COMPLETE, label: 'Complete' },
  ]
}

export const getTaskStatusByLabel = getItemByLabelFactory(getTaskStatii)
export const getTaskStatusById = getItemByIdFactory(getTaskStatii)
